import { render, staticRenderFns } from "./CAJG1070.vue?vue&type=template&id=2057b4b9&scoped=true"
import script from "./CAJG1070Controller.ts?vue&type=script&lang=ts&external"
export * from "./CAJG1070Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CAJG1070.vue?vue&type=style&index=0&id=2057b4b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2057b4b9",
  null
  
)

export default component.exports